import { render, staticRenderFns } from "./Receiving.vue?vue&type=template&id=3155a943"
import script from "./Receiving.vue?vue&type=script&lang=js"
export * from "./Receiving.vue?vue&type=script&lang=js"
import style0 from "./Receiving.vue?vue&type=style&index=0&id=3155a943&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports